import React from 'react';

import { ListContainer } from 'modules/shared-ui/components';
import { ThumbList } from 'modules/shared-cms-advanced/components';

import { DressListProps } from './dress-list-type';

import styles from './dress-list-component.module.css';

export const DressList: React.FC<DressListProps> = React.memo(({ models, fullWidth, children }: DressListProps) => {
    return (
        <ListContainer
            list={models}
            title="MODÈLE"
            noResultsTxt="Aucun modèle n'est disponible dans cette sélection pour l'instant. Nous vous invitons à
        vous rapprocher de l'équipe Mariage du Printemps Haussmann qui saura vous accompagner dans votre recherche."
            fullWidth={fullWidth}
            headerChildren={children}
        >
            <ThumbList
                thumbs={models}
                fullWidth={fullWidth}
                legendStyle={{ marginTop: '1rem' }}
                placeholderClassName={styles.placeholderClassName}
            />
        </ListContainer>
    );
});
